// 简体中文. Keep the keys identical to en.js; anything missing here falls back to English.
// Product terms kept in English on purpose because customers search for them that way:
// HTTP, SOCKS5, OpenVPN, VPN, IP, API, USDT/USDC and the coin and network names (BEP-20, ERC20, TRC20).
export default {
    lang: { label: '语言' },
    theme: { toLight: '切换到浅色主题', toDark: '切换到深色主题' },
    common: { copied: '已复制', notDefined: '未设置', minutes: '{n} 分钟', expired: '已过期', pendingSync: '等待同步', changeIp: '更换 IP', copy: '复制', close: '关闭' },

    nav: {
        buyNewProxy: '购买新代理', myProxy: '我的代理', deposit: '充值 / 交易记录',
        account: '账户', affiliate: '推广计划', apiKey: 'API 密钥', partners: '合作伙伴', faq: '常见问题', logout: '退出登录',
    },

    auth: {
        heroTitle1: '优质 4G 和 5G 移动代理，', heroTitle2: '覆盖全美',
        heroSub: '美国真实运营商网络上的独享移动 IP。',
        statInStock: '可用代理', statCountries: '国家', statCities: '城市',
        signInTitle: '登录', signInSub: '查看您的代理和实时库存',
        email: '邮箱', password: '密码', logIn: '登录', signingIn: '正在登录…',
        createAccount: '创建账户', forgotPasswordLink: '忘记密码？',
        registrationClosed: '注册已关闭', goToSignIn: '前往登录',
        registerTitle: '创建账户', registerSub: '只需一分钟，注册后即可购买您的第一个代理。',
        fullName: '姓名', username: '用户名', confirmPassword: '确认密码', address: '地址',
        addressPlaceholder: '街道和城市', country: '国家', region: '地区', telegram: 'Telegram',
        creatingAccount: '正在创建账户…', haveAccount: '已有账户？立即登录',
        forgotTitle: '忘记密码？', forgotSub: '请输入您的邮箱地址，我们会向您发送重置密码的链接。',
        sendResetLink: '发送重置链接', sending: '正在发送…', backToSignIn: '返回登录',
        resetTitle: '重置密码', resetSub: '请为您的账户设置新密码。', newPassword: '新密码', resetButton: '重置密码',
        recaptchaError: 'reCAPTCHA 验证出错', sendingLink: '正在发送重置密码链接…',
        enterValidEmail: '请先输入有效的邮箱地址，再申请重置链接。',
        v: {
            emailRequired: '请输入邮箱', emailInvalid: '邮箱格式不正确',
            passwordRequired: '请输入密码', passwordMin: '密码至少需要 8 个字符',
            confirmRequired: '请再次输入密码', passwordsMatch: '两次输入的密码不一致',
            userNameRequired: '请输入用户名', fullNameRequired: '请输入姓名',
            addressRequired: '请输入地址', regionRequired: '请选择地区', countryRequired: '请选择国家',
            captcha: '请确认您不是机器人',
        },
    },

    buy: {
        country: '国家', isp: '运营商', city: '城市', package: '套餐', chooseAPackage: '选择套餐',
        inStock: '库存 {n} 个', outOfStock: '无库存',
        autoExtendNote: '购买后可开启自动续费。余额：${balance}',
        openvpnQuestion: '需要 OpenVPN 连接来支持 UDP，或需要操作系统 / IP 指纹伪装吗？',
        yes: '是', no: '否', nextExpiry: '下一个到期：{time}', timePending: '时间待定',
        requestNewLocation: '申请新地区', requestNewStock: '申请补货',
        select: '选择', purchase: '购买',
        dur: { d: '{n}天', hr: '{n}小时', hrs: '{n}小时', min: '{n}分钟', mins: '{n}分钟', under: '不到 1 分钟' },
    },

    stockAlert: {
        title: '{place} 到货时邮件通知我',
        sub: '此处一有代理可用，我们会立即发送一封邮件。库存先到先得。',
        emailPlaceholder: 'name@example.com', notify: '到货通知', saving: '正在保存…',
        done: '{place} 到货时，我们会发送邮件到 {email}。', cancel: '取消',
        invalidEmail: '请输入有效的邮箱地址。',
    },

    chat: {
        you: '你', edited: '已编辑', deleted: '消息已删除', react: '表情回应', statusLooking: '处理中', statusDone: '已完成',
        adviceTry: '试用 Undetectable.io', recommendedPartner: '推荐合作伙伴',
        offlineNow: '离线', backAt: '英国时间 {time} 上线', headerOfflineAt: '英国时间 {time} 上线 · 请留言', headerOfflineManual: '离线 · 请留言',
        support: '客服', onlineNow: '在线', newReply: '{n} 条新回复', newReplies: '{n} 条新回复', openChat: '打开客服聊天', supportTeam: '客服团队',
        dismiss: '关闭', title: 'ProxyWarehouse 客服', close: '关闭', headerOnline: '在线 · 通常几分钟内回复', 
        greeting: '{name}，您好！需要什么帮助？', greetingSub: '选择一个主题或在下方输入。我们在英国时间 {from} 至 {to} 在此回复。', offlineNote: '我们目前不在线。请留言，我们上线后会第一时间回复，回复会显示在这里。',
        quickAnswers: '帮助中心快速解答', read: '阅读', supportLabel: '客服', seen: '已读', today: '今天', yesterday: '昨天', topicDown: '代理无法使用',
        topicRotation: 'IP 轮换', topicBilling: '充值 / 账单', topicAntidetect: '防检测浏览器建议', whichProxy: '是哪个代理？',
        attachProxy: '附上我的代理', attachProxySub: '附带服务器和端口', cancel: '取消', loadingProxies: '正在加载您的代理…', noProxies: '您还没有代理。', expired: '已过期',
        continue: '继续', notSpecific: '不涉及具体代理', attachN: '附上（{n}）', remove: '移除', pictureReady: '图片已就绪 · 点击发送', fileReady: '文件已就绪 · 点击发送', pictureOrFile: '图片或文件',
        pictureOrFileSub: '也可粘贴 / 拖放 · 5 MB', attach: '附件', placeholder: '输入消息…', send: '发送', enterHint: 'Enter 发送 · Shift + Enter 换行',
        dropHere: '将图片或文件拖到此处', sentPicture: '发送了一张图片', sentFile: '发送了一个文件', fileTypes: '只能发送图片或 txt / ovpn / conf / log / csv / json / pdf 文件',
        fileSize: '文件不能超过 5 MB', enterMessage: '请输入消息', adviceTitle: '防检测浏览器建议',
        adviceText: '我们推荐使用 Undetectable.io 进行防检测浏览。每个浏览器配置文件都有独立的指纹，并可添加您的 ProxyWarehouse 代理。', adviceLink: '移动代理设置指南', adviceAsk: '还有问题？请在下方输入。',
    },

    outage: {
        siteTitle: '目前有 {n} 台服务器离线。',
        siteText: '我们已知晓并正在处理。受影响的代理在下方显示提示。',
        offlineTitle: '此服务器当前离线。',
        offlineText: '我们已知晓并正在处理，无需报告。离线开始于 {time}。',
        backTitle: '已恢复在线。',
        backText: '此服务器离线了 {min} 分钟，现已恢复。如果代理仍无法使用，请更换一次 IP。',
        knownIssue: '已知问题：',
        knownText: '{server} 自 {time} 起离线。我们正在处理，无需报告。',
    },

    partner: {
        bannerTitle: '管理多个账号？请使用防检测浏览器。',
        bannerText: '我们的推荐合作伙伴 Undetectable.io 为每个配置文件提供独立指纹。为每个配置文件添加您的 ProxyWarehouse 代理即可。',
        try: '试用 Undetectable.io', close: '关闭',
    },

    partnersPage: {
        title: '合作伙伴', intro: '我们推荐与 ProxyWarehouse 移动代理搭配使用的工具。', recommended: '推荐合作伙伴',
        undetectableLine: '防检测浏览器，可同时管理多个账号，每个账号都有独立的配置文件、指纹和代理。',
        try: '试用 Undetectable.io', guide: '移动代理设置指南', ready: '准备好搭配您的 ProxyWarehouse 代理试用了吗？',
    },

    faqPage: {
        antidetect: '防检测浏览器：Undetectable.io',
        title: '帮助中心', intro: '关于 ProxyWarehouse 移动代理的常见问题解答。找不到答案？我们的团队在 Telegram 和在线客服为您服务（英国时间上午 9 点至晚上 10 点）。',
        search: '搜索问题，例如 欺诈分数、OpenVPN、IP 轮换', questions: '问题', count: '{n} 个问题', countOf: '{shown} / {n} 个问题',
        noMatch: '没有匹配的问题。请换个关键词，或通过在线客服联系我们。', liveSupport: '在线客服',
        guide: '指南', minRead: '阅读约 {n} 分钟', onThisPage: '本页目录', stillStuck: '仍需帮助？',
    },

    featureFilter: {
        phone: 'Phone',
        title: '按功能筛选代理：', ipv6: 'IPv6', openvpn: 'OpenVPN', wireguard: 'WireGuard', osSpoofing: '系统指纹伪装', udp: 'UDP 流量',
        clear: '清除', none: '{country} 没有同时支持这些功能的代理。请选择其他国家，或关闭其中一项。',
    },

    plan: {
        daily: '1 天', weekly: '7 天', monthly: '30 天', perDay: '每天', perDayPrice: '每天 ${price}',
        save: '节省 {pct}%', unlimited: '不限流量', gbPerDay: '每天 {gb} GB',
        rotation: 'IP 最短轮换间隔 {mins} 分钟', rotationOnDemand: '按需轮换 IP',
        httpSocks: 'HTTP 和 SOCKS5', speed: '速度：最高 {n} Mbps', speedShort: '最高 {n} Mbps', osSpoofing: '支持系统指纹伪装', udp: '支持 UDP 流量', wireguard: '支持 WireGuard', openvpn: '支持 OpenVPN', outOfStock: '已售罄', selected: '已选择',
        actionFor: '{action} ${price}',
    },

    purchase: {
        speedNote: '该服务器限速 {n} Mbps。', title: '购买', userPass: '用户名:密码', ipWhitelist: 'IP 白名单', couponCode: '优惠码',
        noCoupons: '该服务器不支持使用优惠码。', couponPlaceholder: '输入优惠码（可选）',
        clearCoupon: '清除优惠码', couponApplied: '已使用优惠码：{label}', quantity: '数量',
        availableHere: '此处可用 {n} 个', onlyAvailable: '此处仅剩 {n} 个', coupon: '优惠码 {code}',
        total: '合计', balanceAfter: '购买后余额', notEnough: ' · 余额不足（当前余额 ${balance}）',
        btnNotEnough: '余额不足', btnCheckCoupon: '请检查优惠码', btnPurchaseFor: '购买 ${price}',
        v: {
            userPassFormat: '请使用 用户名:密码 格式（仅限字母和数字）', userPassRequired: '请输入 用户名:密码',
            ipFormat: 'IP 地址格式不正确', ipRequired: '请输入 IP 地址',
        },
        err: {
            balanceShort: '您的余额为 ${balance}，本订单需要 ${total}。请先充值。',
            checkCoupon: '请检查优惠码，或将其清除。',
            credLength: '用户名和密码至少需要 4 个字符',
            qtyMin: '数量至少为 1', selectPackage: '请先选择套餐', selectCity: '请先选择城市',
            chooseAuth: '请选择 用户名:密码 或 IP 白名单',
            stockChanged: '您购买时库存发生了变化，请选择可用的代理后重试。',
        },
    },

    topup: {
        title: '账户充值', sub: '使用加密货币支付。付款确认后余额将自动到账。',
        currentBalance: '当前余额', chooseCoin: '选择币种', loading: '正在加载支付方式…',
        unavailable: '支付方式暂时不可用，请几分钟后重试或联系客服。',
        stable: '稳定币，1 {ticker} = $1', networksToChoose: '可选 {n} 个网络', chooseNetwork: '选择网络',
        feeLowest: '手续费最低 · 推荐', feeMedium: '手续费中等', feeHighest: '手续费最高',
        howMuch: '您要充值多少？', enterAmount: '输入金额', yourPayment: '您的付款',
        topUp: '充值金额', youSend: '您需发送', network: '网络',
        btnChooseCoin: '请选择币种', btnEnterAmount: '请输入金额', btnCreating: '正在创建账单…',
        btnPay: '支付 {amount} {ticker}', btnPayOn: '通过 {net} 支付 {amount} {ticker}',
        sendPayment: '请发送付款', amountToSend: '发送金额', toAddress: '收款地址',
        amountCopied: '金额已复制', addressCopied: '地址已复制',
        warn: '请仅通过 {net} 发送 {ticker}。通过其他网络发送的付款可能会丢失。',
        trxOnlyTitle: '仅限 TRX', trxNoUsdt: '请勿向此地址发送 USDT，否则将无法入账。', trxUseUsdt: '要用 Tron 网络上的 USDT 付款？请选择 {coin}。', trxSwitch: '切换到 USDT TRC20',
        invoiceCreated: '账单已创建', noPayment: '未收到付款', waitingConfirm: '等待付款确认',
        balanceCredited: '余额已到账', invoiceOpen: '账单有效期剩余 {time}',
        paidMsg: '已收到付款，您的余额已更新。', expiredMsg: '该账单已过期，请重新发起充值。',
        backToOptions: '返回充值选项', startAnother: '再次充值',
        leaveHint: '您可以离开此页面。账单会保留在下方的交易记录中，页面会自动检查您的付款。',
        thisTopUp: '本次充值', creditNote: '余额将按付款确认时的汇率，以实际到账金额入账。',
        stateWaiting: '等待付款', statePaid: '已付款', stateExpired: '已过期',
    },

    history: {
        title: '交易记录', no: '序号', created: '创建时间', type: '交易类型', status: '状态',
        amount: '金额（USD）', paid: '实付金额', hashes: '交易哈希',
        types: { TOPUP: '充值', PURCHASE: '购买', EXTEND: '续费', MANUAL: '手动添加', REFUND: '退款', COMMISSION: '佣金' },
        statuses: { COMPLETED: '已完成', PROCESSING: '处理中', EXPIRED: '已过期', FAILED: '失败', PENDING: '待处理', CANCELLED: '已取消' },
    },

    myproxy: {
        expiredTitle: '已过期 · 此代理已停止工作', expiredSub: '于 {date} 过期。若尚未被他人购买，续费即可恢复。', proxyExpired: '代理已过期', expiredLabel: '过期：', expiredTag: '已过期', osSpoofing: '系统指纹伪装：', osActive: '已启用 · {os}', osOff: '关闭', ppToday: '今日：{used} MB', ppOfGb: '/ {gb} GB', selectStatus: '选择状态', selectView: '选择显示方式', selectPlaceholder: '选择状态',
        expiring24: '24 小时内到期', statusAll: '全部', statusActive: '有效', statusExpired: '已过期', viewCard: '卡片', viewTable: '表格',
        note: '备注：', couponCode: '优惠码：', serverStatus: '服务器状态：', serverOnline: '服务器在线',
        proxyState: '代理{state}',
        states: { online: '在线', rotating: '正在轮换', checking: '检测中', offline: '离线' },
        maxConn: '已超出最大连接数',
        connsTitle: '已使用 {total} / {limit} 个连接（HTTP {http}，SOCKS5 {socks}）',
        ports: '端口（HTTP/SOCKS5）：', proxy: '代理：{name}', copyAll: '全部复制', auth: '认证：', openvpn: 'OpenVPN：', autoExtend: '自动续费：',
        rotationTime: '轮换时间：', remaining: '剩余时间：', remainingValue: '剩余时间：{time}',
        start: '开始：{date}', expire: '到期：{date}', startTime: '开始时间：', expireTime: '到期时间：',
        modemIpv4: '设备 IPv4：', modemIpv6: '设备 IPv6：', modemIpv4Value: '设备 IPv4：{ip}', modemIpv6Value: '设备 IPv6：{ip}',
        download: '下载流量：', actions: '操作',
        regenConfirm: '要生成新的轮换链接吗？旧链接将立即失效。',
        days: '{n} 天 ', hours: '{n} 小时 ', mins: '{n} 分钟',
        buttons: {
            'CHANGE IP (URL)': '更换 IP（链接）', 'GENERATE NEW URL': '生成新链接', 'STATUS API': '状态 API',
            'IP HISTORY': 'IP 历史', 'AUTO ROTATION': '自动轮换', 'REBOOT DEVICE': '重启设备', EXTEND: '续费',
            'OS Spoofing': '系统指纹伪装', VPN: 'VPN', 'VPN ✓': 'VPN ✓', AUTHENTICATION: '认证设置',
        },
        h: {
            no: '序号', note: '备注', coupon: '优惠码', status: '状态', ports: '端口（HTTP / SOCKS5）', auth: '认证',
            autoExtend: '自动续费 / 轮换时间', startExpire: '开始 / 到期时间', ipDownload: '设备 IP / 下载流量', actions: '操作',
        },
    },
};
